import React from "react";
import ReactDOM from "react-dom/client";
import "./ui/styles/index.scss";

/** React Flip Toolkit Samples */
// import "./ui/components/react-flip-toolkit-samples/UpdatingListWithAnimations";

/** Root Chat App */
import App from "./App";

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
	// <React.StrictMode>
	<App />,
	// </React.StrictMode>,
);
